module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMjguNDM5IiBoZWlnaHQ9IjI2MC41OTgiIHZpZXdCb3g9IjAgMCAyMjguNDM5IDI2MC41OTgiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NCIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NCIgZD0iTTUxNy4yMzIsMTEzMC4xMzRWOTU2LjExOGwyMjguNDM5LTg2LjU4MXYxNzQuMDE2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUxNy4yMzEgLTg2OS41MzUpIiBmaWxsPSJsaW1lIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_228.svg
// module id = SRhE
// module chunks = 0